import * as swcHelpers from '@swc/helpers';
import { reducer as reducer$1, actions } from '@grandvisionhq/state';
import { loadReviewWrite, loadReviewSnippet, loadReviewDisplay, updateReviewDisplay } from './actions.js';

const initialState = {
    reviewWrite: null,
    reviewSnippet: null,
    reviewDisplay: null
};
const reviewsReducer = reducer$1(initialState, /**
   * Load widgets
   */ actions.on(loadReviewWrite, (state, action)=>swcHelpers.objectSpread({}, state, {
        reviewWrite: action.payload
    })
), actions.on(loadReviewSnippet, (state, action)=>swcHelpers.objectSpread({}, state, {
        reviewSnippet: action.payload
    })
), actions.on(loadReviewDisplay, (state, action)=>swcHelpers.objectSpread({}, state, {
        reviewDisplay: action.payload
    })
), /**
   * Update widgets
   */ actions.on(updateReviewDisplay, (state, action)=>{
    return state.reviewDisplay !== null ? swcHelpers.objectSpread({}, state, {
        reviewDisplay: swcHelpers.objectSpread({}, state.reviewDisplay, {
            variantId: action.payload.variantId
        })
    }) : state;
}));
var reducer = reviewsReducer;

export { reducer as default, initialState, reviewsReducer };
//# sourceMappingURL=reducer.js.map
